import axios from 'axios';
import { action } from 'mobx';

import BaseAPIStore, { IAPIStore } from '../api.store';
import { SupplyStore } from './supplyStore';

class SupplyUpdateStore extends BaseAPIStore<ISupplyItemType> implements IAPIStore {
  private supplyStore: SupplyStore;

  constructor(supplyStore: SupplyStore) {
    super();
    this.supplyStore = supplyStore;
  }

  @action
  public async request(id: string, newData: ISupplyItemType) {
    const url = this.apiUrl + '/supplies/' + id;
    this.error = undefined;
    this.requesting = true;
    try {
      const response = await axios.put(url, newData, this.authorizeConfigs());
      const responseData = response.data;

      if (responseData.data) {
        this.data = responseData.data;

        if (this.supplyStore.list.data) {
          const index = this.supplyStore.list.data.findIndex((item) => item._id === id);
          if (index >= 0) {
            const newList = [...this.supplyStore.list.data];
            newList[index] = responseData.data;
            this.supplyStore.list.data = newList;
          }
        }
      } else {
        this.error = new Error('Something went wrong.');
      }
    } catch (error) {
      this.error = error;
    }

    this.requesting = false;
  }
}

export default SupplyUpdateStore;
